// SemanticUI-free pre-@plone/components
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LogoImage from '@plone/volto/components/theme/Logo/Logo.svg';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import logoFooter from './logo-footer.png';
import logoHeader from './logo.png';

import type { Content } from '@plone/types';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  logoOf: {
    id: 'Logo of',
    defaultMessage: 'Logo of',
  },
});

type FormState = {
  content: {
    data: Content;
  };
  navroot: {
    data: {
      navroot: Content;
    };
  };
  site: {
    data: Content['@components']['site'];
  };
  form: {
    global: Content;
  };
};

const Logo = ({ isFooterLogo }: { isFooterLogo: boolean }) => {
  const intl = useIntl();
  const site = useSelector<FormState, Content>((state) => state.site.data);
  const rootPath = '/';

  const MainLogoSrc = logoHeader;
  const FooterLogoSrc = logoFooter;

  const logoSrc = isFooterLogo && FooterLogoSrc ? MainLogoSrc : MainLogoSrc;

  return (
    <Link to={rootPath} aria-label={intl.formatMessage(messages.home)}>
      <img
        src={
          logoSrc
            ? logoSrc
            : site['plone.site_logo']
              ? flattenToAppURL(site['plone.site_logo'])
              : LogoImage
        }
        alt={
          intl.formatMessage(messages.logoOf) + ' ' + site['plone.site_title']
        }
      />
    </Link>
  );
};

export default Logo;
